import loadable from '@loadable/component';

// Use @loadable/component which is compatible with Gatsby's SSR
const ClientsCarousel = loadable(() => import('./ClientsCarousel'), {
	fallback: <div></div>,
});

const Clients = () => <ClientsCarousel />;

export default Clients;
